import React, { useEffect, useState } from "react";
import check from "../../assets/images/check.svg";
import { Link } from "react-router-dom";
import StarRating from "../Helper/StarRating";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCartAPI,
  deleteCartItemApi,
  updateCartQuantityAPI,
} from "../features/cartSlice";
import { toast } from "react-toastify";
import {
  fetchWishlist,
  toggleWishlistApi,
  deleteWislistItem,
} from "../features/wishlistSlice";
import defaultimg from "../../assets/images/default-img.png";

const NewArrivalSlider = ({ product, user }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const token = useSelector((state) => state.auth.token);
  const locationData = useSelector((state) => state.location.locationData);
  // console.log("locationData in new arrival slider", locationData);
  const [isIncrementLoading, setIsIncrementLoading] = useState(false);
  const [isDecrementLoading, setIsDecrementLoading] = useState(false);
  const [isWishlistLoading, setIsWishlistLoading] = useState(false);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);
  const [localWishlistStatus, setLocalWishlistStatus] = useState(false);
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);
  const wishlistItems = useSelector((state) => state.wishlist?.wishlistItems);
  useEffect(() => {
    const isInWishlist = Object.values(wishlistItems)?.some(
      (item) => item?._id === product?._id
    );
    setLocalWishlistStatus(isInWishlist);
  }, [wishlistItems, product?._id]);

  let availbleWeight = product.weights.find((w) => w.stock > 0);
  const [selectedWeight, setSelectedWeight] = useState(
    availbleWeight?.weightInGrams
  );
  useEffect(() => {
    const currentWeightObj = product.weights.find(
      (w) => w.weightInGrams === selectedWeight
    );
    if (!currentWeightObj || currentWeightObj.stock <= 0) {
      const nextAvailableWeight = product.weights.find((w) => w.stock > 0);
      if (nextAvailableWeight) {
        setSelectedWeight(nextAvailableWeight.weightInGrams);
      }
    }
  }, [product.weights, selectedWeight]);

  const cartItem = cartItems.find((item) => {
    return (
      item.productId?._id === product?._id &&
      item.weightId?.weightInGrams === selectedWeight
    );
  });

  const isInCart = Boolean(cartItem);

  const handleIncrement = async () => {
    if (cartItem) {
      const stockLimit = token
        ? cartItem.weightId.stock
        : cartItem.weights.find((w) => w.weightInGrams === selectedWeight)
            ?.stock;

      if (cartItem.quantity >= stockLimit) {
        toast.info(`Sorry, only ${stockLimit} items available in stock`);
        return;
      }

      setIsIncrementLoading(true);
      try {
        await dispatch(
          updateCartQuantityAPI(
            token ? cartItem.productId?._id : cartItem.product_id,
            cartItem.quantity + 1,
            cartItem.weightId?._id
          )
        );
      } finally {
        setIsIncrementLoading(false);
      }
    }
  };

  const handleDecrement = async () => {
    if (cartItem) {
      setIsDecrementLoading(true);
      try {
        if (cartItem.quantity > 1) {
          await dispatch(
            updateCartQuantityAPI(
              token ? cartItem.productId?._id : cartItem.product_id,
              cartItem.quantity - 1,
              cartItem.weightId?._id
            )
          );
        } else {
          await dispatch(
            deleteCartItemApi({
              productId: token ? cartItem.productId?._id : cartItem.product_id,
              weightId: cartItem.weightId?._id,
            })
          );
        }
      } finally {
        setIsDecrementLoading(false);
      }
    }
  };

  const handleAddToCart = () => {
    // console.log("selectedWeight in handleAddToCart", selectedWeight);
    const selectedWeightObj = product.weights.find(
      (w) => w.weightInGrams === selectedWeight
    );
    // console.log("selectedWeightObj in new arrival slider", selectedWeightObj);

    if (!selectedWeightObj) {
      toast.error("Selected weight not available");
      return;
    }

    const existingItem = cartItems.find((item) => {
      return (
        item.productId?._id === product._id &&
        item.weightId?._id === selectedWeightObj._id
      );
    });
    // console.log("existingItem in new arrival slider", existingItem);

    if (existingItem) {
      toast.info("Item already exists in the cart");
      return;
    }

    setIsAddToCartLoading(true);
    if (token) {
      dispatch(addToCartAPI(product, selectedWeight))
        .finally(() => setIsAddToCartLoading(false));
      return;
    }

    const cartProduct = {
      ...product,
      selectedWeight: selectedWeightObj,
    };

    dispatch(addToCartAPI(cartProduct))
      .finally(() => setIsAddToCartLoading(false));
  };

  const handleAddToWishlist = (productId) => {
    try {
      setIsWishlistLoading(true);
      setLocalWishlistStatus(!localWishlistStatus);
      dispatch(toggleWishlistApi(productId));
    } catch (error) {
      setLocalWishlistStatus(localWishlistStatus);
      toast.error("Failed to update wishlist");
    } finally {
      setIsWishlistLoading(false);
    }
  };

  const getDisplayPrice = (product, selectedWeight) => {
    if (!locationData) {
      return { original: "N/A", discounted: "N/A" };
    }
    const weightObj = product.weights.find(
      (w) => w.weightInGrams === selectedWeight
    );
    if (!weightObj) return { original: "N/A", discounted: "N/A" };
    // console.log(
    //   "locationData in new arrival slider inside getDisplayPrice",
    //   locationData.conversionRate
    // );
    // console.log(locationData.currency === "INR", "boolean value");
    let basePrice;
    if (locationData.currency) {
      basePrice =
        locationData.currency === "INR"
          ? weightObj.prices.India
          : weightObj.prices.Other * locationData.conversionRate;
    } else {
      basePrice = weightObj.prices.India;
    }
    // console.log(
    //   "basePrice in new arrival slider inside getDisplayPrice",
    //   basePrice
    // );
    const discountedPrice =
      basePrice - (basePrice * product.discount_percentage) / 100;

    return {
      original: basePrice.toFixed(2),
      discounted: discountedPrice.toFixed(0),
    };
  };

  const isOutOfStock = (product) => {
    const selectedWeightObj = product.weights.find(
      (w) => w.weightInGrams === selectedWeight
    );
    return !selectedWeightObj || selectedWeightObj.stock <= 0;
  };

  const areAllVariantsOutOfStock = (product) => {
    return !product.weights.some((w) => w.stock > 0);
  };

  return (
    <>
      <div key={product._id} className="product-card">
        <div className="product-img">
          <Link to={`/productdetails/${product.slug}`}>
            <img
              src={
                product?.productImages?.length > 0 && product?.productImages[0]
                  ? `${product.productImages[0]}`
                  : defaultimg
              }
              alt={product.productName}
            />
            {product.discount_percentage && (
              <span className="off">{product.discount_percentage}% OFF</span>
            )}
          </Link>
        </div>
        <div className="product-content">
          <p className="auth">
            {product.authentic && (
              <span className="d-flex">
                <img src={check} className="me-1" alt="check" />
                Authentic{" "}
              </span>
            )}

            {!isOutOfStock(product) && (
              <span className="text-success">
                <i className="fas fa-check me-1" />
                In stock
              </span>
            )}
          </p>
          <h5>
            <Link to={`/productdetails/${product.slug}`}>
              {product.productName}
            </Link>
          </h5>
          <p className="rating">
            <StarRating rating={product?.averageRating || 0} />
          </p>
          <div className="price-txt-content">
            {!areAllVariantsOutOfStock(product) ? (
              <>
                <p className="price">
                  {product?.discount_percentage > 0 ? (
                    <>
                      <span className="discounted-price m-2">
                        {locationData && locationData.currency
                          ? locationData.currency
                          : ""}{" "}
                        {getDisplayPrice(product, selectedWeight).discounted}
                      </span>
                      <del className="ms-2 original-price">
                        {locationData && locationData.currency
                          ? locationData.currency
                          : ""}{" "}
                        {getDisplayPrice(product, selectedWeight).original}
                      </del>
                    </>
                  ) : (
                    <span className="regular-price">
                      {locationData && locationData.currency
                        ? locationData.currency
                        : ""}{" "}
                      {getDisplayPrice(product, selectedWeight).original}
                    </span>
                  )}
                </p>
                <span className="qtnty">{availbleWeight?.weightInGrams}gm</span>
              </>
            ) : (
              <span className="text-danger">Out of stock</span>
            )}
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <button
              className="fav-btn"
              onClick={() => handleAddToWishlist(product._id)}
            >
              <i
                className={`${
                  localWishlistStatus ? "fas fa-heart" : "fa-regular fa-heart"
                }`}
              />
            </button>
            {!isInCart ? (
              !isOutOfStock(product) ? (
                <button
                  onClick={handleAddToCart}
                  className="thm-btn"
                  disabled={isOutOfStock(product) || isAddToCartLoading}
                >
                  {isAddToCartLoading ? (
                    <span className="spinner-border spinner-border-sm me-1" />
                  ) : (
                    <i className="fas fa-shopping-basket me-1" />
                  )}
                  Add to Cart
                </button>
              ) : (
                <button
                  className="thm-btn secondary"
                  data-product-id={product._id}
                  data-bs-toggle="modal"
                  data-bs-target="#notify-modal"
                >
                  <i className="fas fa-envelope me-2"></i>Notify
                </button>
              )
            ) : (
              <div className="quantity-controls d-flex align-items-center">
                <button
                  onClick={handleDecrement}
                  className="quantity-controls-btn"
                  disabled={isDecrementLoading}
                >
                  {isDecrementLoading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "-"
                  )}
                </button>
                <span className="mx-2">{cartItem?.quantity || 0}</span>
                <button
                  onClick={handleIncrement}
                  className="quantity-controls-btn"
                >
                  {isIncrementLoading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "+"
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewArrivalSlider;
